<template>
  <Register />
</template>

<script>
import Register from '../components/Regsiter.vue'
export default {
  name: 'Register-page',
  components: {
    Register
  }
}
</script>
